import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import pagination from "shetabit-laravel-vue-pagination";
import VueMeta from 'vue-meta'
import vImage from "v-img"
import Axios from "axios";
import vuetify from "./plugins/vuetify";
import "swiper/swiper-bundle.css";
import "./assets/styles/MainStyles.css";
import "./assets/styles/EnStyles.css";
import AOS from "aos";
import VueCookie from "vue-cookie";
import "aos/dist/aos.css";
Axios.defaults.baseURL = "https://gorgon.ir/v1/";
import VueAgile from 'vue-agile'
import './registerServiceWorker' 
Vue.component("pagination", pagination);
Vue.use(VueAgile)
Vue.prototype.$axios = Axios;
Vue.config.productionTip = false;
AOS.init();
Vue.use(VueCookie);
Vue.use(VueMeta);
Vue.use(vImage)
Vue.use(Toast);
new Vue({
    created() {
       
        this.$axios.defaults.headers.common["Accept-Language"] = this.$cookie.get(
                "language"
            ) ?
            this.$cookie.get("language") :
            "fa";
        if (this.$cookie.get('language')) {
            if (this.$cookie.get('language') != 'fa') {
                document.body.classList.add('ltrStyle')
            }
        }
    },
    computed: {
        globalData() {
            return this.$store.getters.getGlobalData
        }
    },
    methods: {
        initSwiper(name, kill = false, callback) {
            let action = () => {
                    if (kill) {
                        this.disabledSliders.push(name)
                    }
                    setTimeout(() => {
                        if (kill) {
                            this.disabledSliders = this.disabledSliders.filter(item => item != name)
                        }
                        setTimeout(() => {
                            callback()
                        }, 0)
                    }, 0)
                }
                // بعضی جاها مثل اینکه باید باشه اینجا نداشتم . in mobile for swiper bug
            if (window.innerWidth < 768 & false) {
                setTimeout(() => {
                    action()
                }, 800)
            } else {
                action()
            }
        },
    },
    router,
    store,
    vuetify,
    render: function(h) {
        return h(App);
    }
}).$mount("#app");